import { useTranslation } from 'react-i18next'

const FulfillmentIssueResolvedEventItemType = ({ event }) => {
    const [t] = useTranslation()
    const [customerAckType,orderItemName] = event.context.split(':')

    return `${t(`order.customerAckType.${customerAckType}`)}: ${orderItemName}`
}

export { FulfillmentIssueResolvedEventItemType }
